import React, { createContext, useContext, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import "./CookieConsent.css"


function CookieConsent(props) {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.cookie
    const history = useHistory()

    return (
        <div className="cookie-banner">
            <div>
            {lang.cookie_desc}&nbsp;
            <a href="#"
            onClick={(e)=>{
                e.preventDefault()
                history.push("/view-term")
            }}>
                {lang.term_policy}
            </a>
            </div>
            <div style={{marginLeft:20}}>
                <Button
                onClick={props.onClickAccept}
                >
                    {lang.accept}
                </Button>
            </div>
        </div>
    )
}

function CookieProvider(props){
    const acceptCookie = localStorage.getItem("accept-cookie")
    const [accepted, setAccepted] = useState(acceptCookie !== null ? true:false)

    const setAcceptCookie = (status) =>{
        localStorage.setItem("accept-cookie", status)
        setAccepted(true)
    }
    
    return(
        <>
            { acceptCookie === null && !accepted ?
                <CookieConsent
                onClickAccept={()=>setAcceptCookie("yes")}
                />
            : null
            }
            {props.children}
        </>
    )
}

export { CookieProvider }
